import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgBankIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path d="M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor" />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 10h12v7H6z"
    />
    <path d="M9 10v7M12 10v7M15 10v7" stroke="currentColor" strokeWidth={1.5} />
    <path
      d="M4 20h16M19.5 9.5h-15V8L12 4.5 19.5 8v1.5Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgBankIcon);
const Memo = memo(ForwardRef);
export default Memo;
